import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Button } from 'reactstrap';
import './ModalCrearUsuario.css';

function ModalCesoForm({ isOpen, onClose, onSave, row, usuarios, tiposCese, estadosCulminacion, estadosDespido }) {
  const [form, setForm] = useState({
    id_usuario: '',
    tipo_ceso: '1',
    observacion: '',
    estado: '1',
  });

  useEffect(() => {
    if (!isOpen) return;
    if (row) {
      setForm({
        id_usuario: row.id_usuario != null ? String(row.id_usuario) : '',
        tipo_ceso: row.tipo_ceso != null ? String(row.tipo_ceso) : '1',
        observacion: row.observacion || '',
        estado: row.estado != null ? String(row.estado) : '1',
      });
    } else {
      setForm({
        id_usuario: '',
        tipo_ceso: '1',
        observacion: '',
        estado: '1',
      });
    }
  }, [isOpen, row]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => {
      const next = { ...prev, [name]: value };
      if (name === 'tipo_ceso' && row && Number(row.estado) === 1) {
        next.estado = '1';
      }
      return next;
    });
  };

  const handleSubmit = async () => {
    if (!form.id_usuario) return alert('Seleccione el colaborador.');
    const payload = {
      id_usuario: Number(form.id_usuario),
      tipo_ceso: Number(form.tipo_ceso),
      observacion: form.observacion.trim() || null,
    };
    if (row) {
      payload.id_cese = row.id_cese;
      payload.estado = Number(form.estado);
    }
    try {
      await onSave(payload);
      onClose(true);
    } catch (error) {
      console.error(error);
      alert(error.response?.data?.message || 'Error al guardar.');
    }
  };

  const bloqueadoInicial = row && Number(row.estado) !== 1;
  const tipoNum = Number(form.tipo_ceso);
  const listaEstados = tipoNum === 1 ? estadosCulminacion || [] : estadosDespido || [];

  return (
    <Modal isOpen={isOpen} fade={false} className="custom-modal" backdrop="static" size="md">
      <ModalHeader className="modal-header">
        <div className="titulo">
          <h1>{row ? 'EDITAR REGISTRO' : 'NUEVO REGISTRO'}</h1>
          <Button className="close-btn" onClick={() => onClose(false)}>
            X
          </Button>
        </div>
      </ModalHeader>
      <div className="modal-body-footer">
        <ModalBody className="modal-body">
          <Form className="fila" onSubmit={(e) => e.preventDefault()}>
            <FormGroup>
              <Label>
                Colaborador: <span style={{ color: 'red' }}>*</span>
              </Label>
              <Input
                type="select"
                name="id_usuario"
                className="form-control"
                value={form.id_usuario}
                onChange={handleChange}
                disabled={bloqueadoInicial}
              >
                <option value="">Seleccionar</option>
                {(usuarios || []).map((o) => (
                  <option key={String(o.usuario_id)} value={String(o.usuario_id)}>
                    {o.nombre_completo || o.usuario_id}
                  </option>
                ))}
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>Tipo de cese</Label>
              <Input
                type="select"
                name="tipo_ceso"
                className="form-control"
                value={form.tipo_ceso}
                onChange={handleChange}
                disabled={bloqueadoInicial}
              >
                {(tiposCese || []).map((t) => (
                  <option key={String(t.tipo_id)} value={String(t.tipo_id)}>
                    {t.descripcion || t.tipo_id}
                  </option>
                ))}
              </Input>
            </FormGroup>
            {row && (
              <FormGroup>
                <Label>Estado</Label>
                <Input type="select" name="estado" className="form-control" value={form.estado} onChange={handleChange}>
                  {listaEstados.map((t) => (
                    <option key={String(t.tipo_id)} value={String(t.tipo_id)}>
                      {t.descripcion || t.tipo_id}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            )}
            <FormGroup>
              <Label>Observación</Label>
              <Input
                type="textarea"
                name="observacion"
                className="form-control"
                rows={3}
                value={form.observacion}
                onChange={handleChange}
              />
            </FormGroup>
            <FormGroup>
              <div className="button-container">
                <Button className="button-custom" onClick={handleSubmit}>
                  {row ? 'ACTUALIZAR' : 'REGISTRAR'}
                </Button>
              </div>
            </FormGroup>
          </Form>
        </ModalBody>
      </div>
    </Modal>
  );
}

export default ModalCesoForm;
